// mantine
import { Select } from '@mantine/core';
// utils
import { uniqBy } from 'es-toolkit';
import { IModelType } from '@/types/common.ts';
import { useProvidersQuery } from '@/services/customer/providers/providers.queries.ts';

interface ModelFieldProps {
    label?: string;
    value: IModelType | null;
    onChange: (value?: IModelType) => void;
}

const ModelField = ({ label = 'Model', value, onChange }: ModelFieldProps) => {
    const { data: providers = [] } = useProvidersQuery();
    const groups = providers.map((provider) => {
        return {
            group: provider.title,
            // TODO: remove uniqBy once API is fixed, https://newoai.atlassian.net/browse/ABP-2024
            items: uniqBy(provider.models, (model) => model.idn).map(
                (model) => ({
                    value: `${provider.idn}/${model.idn}`,
                    label: `${provider.idn}/${model.idn}`
                })
            )
        };
    });
    const selectedOption = value
        ? `${value.provider_idn}/${value.model_idn}`
        : undefined;
    const handleChange = (selectedValue: string | null) => {
        if (selectedValue) {
            const [providerIdn, modelIdn] = selectedValue.split('/');
            onChange({
                provider_idn: providerIdn,
                model_idn: modelIdn
            });
        }
    };
    return (
        <Select
            comboboxProps={{ withinPortal: false }}
            data={groups}
            label={label}
            value={selectedOption}
            onChange={handleChange}
        />
    );
};

export default ModelField;
